<template>
  <div class="dv-board-num" :ref="ref">
    <svg width="100%" height="100%">
        <g v-if="mergedNum == 1" id="NO1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="画板" transform="translate(-387.000000, -334.000000)" fill-rule="nonzero">
                <g id="编组-22" transform="translate(387.000000, 334.000000)">
                    <path d="M17.5671487,3.03406427 L12.9790516,3.97186594 C12.8028469,4.07998896 12.6311604,4.02592746 12.5125611,3.86153633 L9.31602865,0.165494418 C9.20194745,-0.0551648059 8.84953823,-0.0551648059 8.73545705,0.165494418 L5.53892458,3.86263963 C5.42484338,4.03034063 5.24863877,4.08550545 5.07243415,3.97296924 L0.488855092,3.03516757 C0.256174639,2.86746656 -0.0917165314,3.14439388 0.022364667,3.4202179 L1.35632396,17.832299 C1.41279979,17.8874638 1.53252858,18 1.64660978,18 L16.5189571,18 C16.6330383,18 16.8092429,17.8907737 16.8092429,17.7793408 L17.9726452,3.36505308 C18.0912445,3.08922906 17.7998291,2.87187974 17.5660192,3.03516757 L17.5671487,3.03406427 Z" id="形状" fill="#FE0909"></path>
                    <polygon id="1" fill="#FFFFFF" points="9.547 15 9.547 5.835 8.182 5.835 5.569 6.615 5.985 8.253 7.571 7.863 7.571 15"></polygon>
                </g>
            </g>
        </g>
        <g v-if="mergedNum == 2" id="NO2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="画板" transform="translate(-387.000000, -369.000000)" fill-rule="nonzero">
                <g id="编组-22" transform="translate(387.000000, 369.000000)">
                    <path d="M17.5671487,3.03406427 L12.9790516,3.97186594 C12.8028469,4.07998896 12.6311604,4.02592746 12.5125611,3.86153633 L9.31602865,0.165494418 C9.20194745,-0.0551648059 8.84953823,-0.0551648059 8.73545705,0.165494418 L5.53892458,3.86263963 C5.42484338,4.03034063 5.24863877,4.08550545 5.07243415,3.97296924 L0.488855092,3.03516757 C0.256174639,2.86746656 -0.0917165314,3.14439388 0.022364667,3.4202179 L1.35632396,17.832299 C1.41279979,17.8874638 1.53252858,18 1.64660978,18 L16.5189571,18 C16.6330383,18 16.8092429,17.8907737 16.8092429,17.7793408 L17.9726452,3.36505308 C18.0912445,3.08922906 17.7998291,2.87187974 17.5660192,3.03516757 L17.5671487,3.03406427 Z" id="形状" fill="#FE7900"></path>
                    <path d="M12.8215,15 L12.8215,13.271 L8.8565,13.271 L10.3385,12.127 C11.9505,10.879 12.7305,10.125 12.7305,8.604 L12.7305,8.578 C12.7305,6.875 11.4825,5.77 9.5975,5.77 C7.9725,5.77 7.1015,6.433 6.2045,7.655 L7.6085,8.786 C8.2845,7.954 8.7655,7.564 9.4675,7.564 C10.1825,7.564 10.6895,7.98 10.6895,8.747 C10.6895,9.501 10.2475,9.995 9.1165,10.931 L6.0875,13.414 L6.0875,15 L12.8215,15 Z" id="2" fill="#FFFFFF"></path>
                </g>
            </g>
        </g>
        <g v-if="mergedNum == 3" id="NO3" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="画板" transform="translate(-387.000000, -403.000000)" fill-rule="nonzero">
                <g id="编组-22" transform="translate(387.000000, 403.000000)">
                    <path d="M17.5671487,3.03406427 L12.9790516,3.97186594 C12.8028469,4.07998896 12.6311604,4.02592746 12.5125611,3.86153633 L9.31602865,0.165494418 C9.20194745,-0.0551648059 8.84953823,-0.0551648059 8.73545705,0.165494418 L5.53892458,3.86263963 C5.42484338,4.03034063 5.24863877,4.08550545 5.07243415,3.97296924 L0.488855092,3.03516757 C0.256174639,2.86746656 -0.0917165314,3.14439388 0.022364667,3.4202179 L1.35632396,17.832299 C1.41279979,17.8874638 1.53252858,18 1.64660978,18 L16.5189571,18 C16.6330383,18 16.8092429,17.8907737 16.8092429,17.7793408 L17.9726452,3.36505308 C18.0912445,3.08922906 17.7998291,2.87187974 17.5660192,3.03516757 L17.5671487,3.03406427 Z" id="形状" fill="#1459FF"></path>
                    <path d="M9.5065,15.156 C11.5345,15.156 12.7825,13.895 12.7825,12.179 L12.7825,12.153 C12.7825,10.463 11.5735,9.813 10.3385,9.605 L12.6395,7.408 L12.6395,5.9 L6.4905,5.9 L6.4905,7.616 L10.0655,7.616 L7.8945,9.8 L8.2065,11.074 L9.0385,11.074 C10.1565,11.074 10.8195,11.49 10.8195,12.231 L10.8195,12.257 C10.8195,12.933 10.2865,13.362 9.5325,13.362 C8.6095,13.362 7.9595,12.972 7.3355,12.27 L5.9575,13.583 C6.7375,14.506 7.8685,15.156 9.5065,15.156 Z" id="3" fill="#FFFFFF"></path>
                </g>
            </g>
        </g>
    </svg>
  </div>
</template>

<script>
import autoResize from '@jiaminghi/data-view/lib/mixin/autoResize'

import { deepMerge } from '@jiaminghi/charts/lib/util/index'

import { deepClone } from '@jiaminghi/c-render/lib/plugin/util'

export default {
  name: 'boardNum',
  mixins: [autoResize],
  props: {
    num: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      ref: 'board-num',

      autoNum:1,
      mergedNum:1
    }
  },
  watch: {
    num () {
      const { mergeNum } = this

      mergeNum()
    }
  },
  methods: {

    mergeNum () {
      const { num, autoNum } = this

      this.mergedNum = deepMerge(deepClone(autoNum, true), num || [])
    }
  },
  mounted () {
    const { mergeNum } = this

    mergeNum()
  }
}
</script>
<style lang="scss" type="text/scss">
    .dv-board-num {
        width: 100%;
        height: 100%;
    }

</style>